import { AIChatLauncherPosition } from '../../../../types/graphql'
import { TanstackField } from '../../../utils/forms'
import AIChatLauncherPositionSelect from '../../Selects/AIChatLauncherPositionSelect'

type Props<TKey extends string> = {
  field: TanstackField<AIChatLauncherPosition | null | undefined, TKey>
  label: React.ReactNode
}
const AIChatLauncherPositionSelectField = <TKey extends string>({ field, label }: Props<TKey>) => {
  return (
    <AIChatLauncherPositionSelect
      label={label}
      onValueChange={field.setValue}
      value={field.state.value}
    />
  )
}

export default AIChatLauncherPositionSelectField
